<template>
    <form
        class="flex flex-col gap-5"
        @submit="onSubmit"
    >
        <div class="form-titled-item">
            <span class="text-sm font-medium">Expiry date</span>
            <MPDatetime
                vid="expiry_date"
                :min-date="new Date()"
            />
        </div>
        <DocumentExpiryFile
            v-if="documentReminders && data"
            ref="reminderEditor"
            :file="data"
            :resource-name="resourceName"
            :expiry-date="form.values.expiry_date || ''"
            editable
            defer-save
            @expiry-changed="form.setFieldValue('expiry_date', $event)"
        />
        <div class="flex flex-col justify-end gap-2 md:flex-row">
            <MuvalButton
                cancelBtn
                class="order-2 md:order-1"
                type="button"
                @click.prevent="emit('cancel:modal')"
            >
                Cancel
            </MuvalButton>
            <MuvalButton
                :loading="form?.isSubmitting"
                class="order-1 md:order-2"
                >Save</MuvalButton
            >
        </div>
    </form>
</template>

<script setup>
import DocumentExpiryFile from '@components/company-diary/DocumentExpiryFile.vue';
import { useForm } from 'vee-validate';

const reminderEditor = ref(null);
const props = defineProps({
    documentReminders: { type: Boolean, default: false },
    resourceName: { type: String, default: '' },
    data: {
        type: Object,
        required: true,
    },
    url: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['cancel:modal', 'close:modal']);

const form = reactive(useForm());

const onSubmit = form.handleSubmit(async (values) => {
    try {
        let payload = {
            collection_name: props.data.collection_name,
            ...values,
        };
        await window.tenantAxios.patch(`${props.url}/${props.type}/${props.data.id}`, payload);
        props.data.custom_properties = { ...props.data.custom_properties, expiry_date: values.expiry_date || null };
        if ((await reminderEditor.value?.savePending()) === false) return;
        emit('close:modal');
    } catch (e) {
        form.setErrors(e.response?.data?.errors ?? {});
        console.error(`Error updating file: ${e}`);
    }
});

onMounted(() => {
    form.resetForm({
        values: {
            expiry_date: props.data.custom_properties.expiry_date,
        },
    });
});
</script>
